import React from 'react';
import { Box } from '@stockx/ui';
// import { BlackFridayTimerBanner } from '@app/blackfriday';

import {
  useShowLocationSelectorBanner,
  LocationSelector,
} from '@app/locationSelector';
import { VacationMode, SellerShipBy, HyperwalletNag } from './components';

const InlineNotification = () => {
  const showLocationSelectorBanner = useShowLocationSelectorBanner();

  return (
    <Box data-component="InlineNotification">
      <SellerShipBy />
      <HyperwalletNag />
      <VacationMode />
      {/* <BlackFridayTimerBanner /> */}

      {showLocationSelectorBanner && <LocationSelector />}
    </Box>
  );
};

export default InlineNotification;
